// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-site-wide." + {"193":"cae4866051e3efc9","750":"9e1d207e682f4d07"}[chunkId] + ".js";
};